import { ReactQueryDevtools as Devtools } from '@tanstack/react-query-devtools'
import { useState } from 'react'

/**
 * React Query の カスタムDevtools
 */
export function ReactQueryDevtools() {
  const [toggleButtonGrayscale, setToggleButtonGrayscale] = useState(1)

  return (
    <Devtools
      position="bottom-right"
      initialIsOpen={false}
      toggleButtonProps={{
        onMouseEnter: () => {
          setToggleButtonGrayscale(0)
        },
        onMouseLeave: () => {
          setToggleButtonGrayscale(1)
        },
        style: {
          width: 25,
          height: 25,
          margin: '16px 8px',
          transition: 'filter 0.5s',
          filter: `grayscale(${toggleButtonGrayscale})`,
        },
      }}
    />
  )
}
